import { LuxPalette } from 'types/colors';

export const luxPalette: LuxPalette = {
  primary: {
    0.5: '#EBEBFF',
    1: '#D8D5FF', // disabled
    2: '#B4B1FF', // hover
    3: '#908DFF',
    4: '#6C69FF',
    5: '#4845FF', // enabled
    6: '#3C3CE0',
    7: '#3232BE',
    8: '#28289C', // active
    9: '#1E1E7A',
    10: '#141458',
    11: '#0A0A36',
    12: '#000014',
  },
  neutral: {
    0.5: '#FAFAFA',
    1: '#F2F2F7', // background
    2: '#E5E5EA', // outline
    3: '#D1D1D6', // selected list
    4: '#C7C7CC',
    5: '#AEAEB2', // disabled text/icon
    6: '#8E8E93',
    7: '#8E8E93',
    8: '#636366', // icons
    9: '#48484A',
    10: '#3A3A3C', // secondary text
    11: '#2C2C2E',
    12: '#1C1C1E',
  },
  alert: {
    0.5: '#FFECEB',
    0: '#FFC8C5',
    1: '#FF6A62',
    5: '#FF3B30',
    10: '#C22D24',
  },
  caution: {
    0.5: '#FFF7EB',
    0: '#FFE1B8',
    1: '#FFAE3D',
    5: '#FF9500',
    10: '#C27100',
  },
  attention: {
    0.5: '#FFFBEB',
    0: '#FFF1B8',
    1: '#FFD83D',
    5: '#FFCC00',
    10: '#B29B00',
  },
  success: {
    0.5: '#EFFBF2',
    0: '#C6EFD1',
    1: '#65D481',
    5: '#34C759',
    10: '#1F7735',
  },
  info: {
    0.5: '#E5F2ff',
    0: '#B8DAFF',
    1: '#3D9BFF',
    5: '#005CBF',
    10: '#004A99',
  },
  extremes: {
    black: '#000205', // main text
  },
};

export const luxSemantics = {
  cyan: {
    1: '#E5F6FF',
    2: '#BAE6FF',
    3: '#82CFFF',
    4: '#33B1FF',
    5: '#1192E8',
    6: '#0072C3',
    7: '#00539A',
    8: '#003A6D',
    9: '#012749',
    10: '#061727',
  },
  green: {
    1: '#DEFBE6',
    2: '#A7F0BA',
    3: '#6FDC8C',
    4: '#42BE65',
    5: '#24A148',
    6: '#198038',
    7: '#0E6027',
    8: '#044317',
    9: '#022D0D',
    10: '#071908',
  },
  magenta: {
    1: '#FFF0F7',
    2: '#FFD6E8',
    3: '#FFAFD2',
    4: '#FF7EB6',
    5: '#EE5396',
    6: '#D02670',
    7: '#9F1853',
    8: '#740937',
    9: '#510224',
    10: '#2A0A18',
  },
  orange: {
    1: '#FFF2E8',
    2: '#FFD9BE',
    3: '#FFB784',
    4: '#FF832B',
    5: '#EB6200',
    6: '#BA4E00',
    7: '#8A3800',
    8: '#5E2900',
    9: '#3E1A00',
    10: '#231000',
  },
  purple: {
    1: '#F6F2FF',
    2: '#E8DAFF',
    3: '#D4BBFF',
    4: '#BE95FF',
    5: '#A56EFF',
    6: '#8A3FFC',
    7: '#6929C4',
    8: '#491D8B',
    9: '#31135E',
    10: '#1C0F30',
  },
  teal: {
    1: '#D9FBFB',
    2: '#9EF0F0',
    3: '#3DDBD9',
    4: '#08BDBA',
    5: '#009D9A',
    6: '#007D79',
    7: '#005D5D',
    8: '#004144',
    9: '#022B30',
    10: '#081A1C',
  },
  yellow: {
    1: '#FCF4D6',
    2: '#FDDC69',
    3: '#F1C21B',
    4: '#D2A106',
    5: '#B28600',
    6: '#8E6A00',
    7: '#684E00',
    8: '#483700',
    9: '#302400',
    10: '#1C1500',
  },
};
